import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isApprovedVendorUser } from '../../utils/authRoles';

const VendorGuard = ({ children, fallback = null }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { isAuthenticated, loading, user, profile } = useSelector((state) => state.auth);

  if (loading || (isAuthenticated && !profile?.rails_profile)) {
    return fallback;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!isApprovedVendorUser(user, profile)) {
    return (
      <Navigate
        to="/"
        replace
        state={{
          message: t('vendor.guard.accessRequired'),
        }}
      />
    );
  }

  return children;
};

export default VendorGuard;
